import { useSelector } from "react-redux";

const useNotifications = () => {
    const newNotificationsCount = useSelector((state) => state.newNotificationsCount);
    return newNotificationsCount;
};

export default useNotifications;